import { connect, ConnectedProps } from "react-redux";
import {
  updateUserPassenger,
  setUserSelectedPassengerIds,
  deleteUserPassenger,
  fetchUserPassengers,
  fetchCorpUserPassengers,
} from "../../actions/actions";
import {
  getUserPassengerCallState,
  getUserPassengers,
  getUserSelectedTravelerId,
  getHotelBookSelectedAvailabilityCheckInMinimumAge,
  getFromDateInBook,
} from "../../reducer";
import { IStoreState } from "../../../../reducers/types";
import { HotelBookPassengerSelection } from "./component";
import { getIsTravelApp } from "../../../availability/reducer";

const mapStateToProps = (state: IStoreState) => ({
  travelers: getUserPassengers(state),
  selectedTravelerId: getUserSelectedTravelerId(state),
  userPassengerCallState: getUserPassengerCallState(state),
  isTravelApp: getIsTravelApp(state),
  minimumCheckInAge: getHotelBookSelectedAvailabilityCheckInMinimumAge(state),
  checkInDate: getFromDateInBook(state),
});

const mapDispatchToProps = {
  updateUserPassenger,
  setUserSelectedPassengerIds,
  deleteUserPassenger,
  fetchUserPassengers,
  fetchCorpUserPassengers,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type HotelBookPassengerSelectionConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedHotelBookPassengerSelection = connector(
  HotelBookPassengerSelection
);
